export const UPDATE_GLOBAL_SETTING = 'UPDATE_GLOBAL_SETTING';
export const updateGlobalSetting = (key, value) => {
  return {
    type: UPDATE_GLOBAL_SETTING,
    key,
    value
  }
};
